import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AccountParentSVG from './icon-account-parent.svg';

type Props = {
    color?: string;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <AccountParentSVG {...validProps} color={props.color || colors.company} />;
}
SvgComponent.iconName = 'accountParent';

/**
 * @deprecated This is a legacy icon
 */
export const AccountParentIcon = svgIconWrapper(SvgComponent);
